/** * * Asynchronously loads the component for
Resource Center
* */ import { lazyLoad } from "utils/loadable";
export const ResourceCenter = lazyLoad(
  () => import("./index"),
  (module) => module.ResourceCenter
);
